export const RESPONSE_ERROR_CODES = {
    unhandledError: {
        desc: "Unhandled Error",
        visibleText: "Unhandled error from server",
    },
    "-1": {
        desc: "Connection Error",
        visibleText: "Can't connect to API",
    },
    "400.1": {
        desc: "Invalid username or password",
        visibleText: "Invalid username or password",
    },
    "401": {
        desc: "Unauthorized",
        visibleText: "Authorization has been denied for this request",
    },
    "403.1": {
        desc: "Soft Lock",
        visibleText:
            "Your account is temporarily locked out. Please wait 15 minutes and try again or contact your administrator.",
    },
    "403.2": {
        desc: "Hard Lock",
        visibleText:
            "Account is locked out. Please contact your admin or Databank support to unlock account",
    },
    "403.3": {
        desc: "Session limit reached",
        visibleText:
            "You have reached the maximum number of sessions allowed. Please end a session in your browser or My Profile page.",
    },
};
